import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { SvgIcon, Tooltip, Typography, useTheme } from '@mui/material';
import { InfoCircle } from '../../../../assets';
import { useTranslation } from 'react-i18next';
import { ReportNavItem } from './ReportTypesData';
import { cloneElement } from 'react';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

export interface ReportDialogProps {
  open: boolean;
  reportItem: ReportNavItem;
  onClose: () => void;
}

const ReportDialog = (props: ReportDialogProps) => {
  const { t } = useTranslation('common');
  const { reportItem } = { ...props };
  const theme = useTheme();

  const formContent = reportItem.form ? (
    cloneElement(reportItem.form, {
      onClose: props.onClose,
    })
  ) : null;

  return (
    <Dialog open={props.open}
      onClose={props.onClose}
      maxWidth='md'
      fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <SvgIcon sx={{ width: '20px', mr: '5px' }}>{reportItem.icon}</SvgIcon>
        <Typography variant="textXL"
          sx={{ display: 'flex', flex: 1, justifyContent: 'left', alignItems: 'center' }}>{t(reportItem.title)}
          <Tooltip title={t(reportItem.info)}>
            <SvgIcon sx={{ width: '20px', ml: '5px' }}><InfoCircle color={theme.palette.custom.blue[500]} /></SvgIcon>
          </Tooltip>
        </Typography>
        <CloseDialogAction onCancel={props.onClose} />
      </DialogTitle>
      <DialogContent>
        {formContent}
      </DialogContent>
    </Dialog>
  );
};

export default ReportDialog;